import { Card, Col } from "react-bootstrap";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Chart } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo } from "react";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import moment from "moment/min/moment-with-locales";
import { lineTrendOptions } from "../chartOptions";

ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function RatingsTrend({ data, loading, error }) {
    const chartData = useMemo(() => {
        if (data) {
            return {
                labels: data.map(x => moment(x.basis_week).format("L")),
                datasets: [
                    {
                        type: "line",
                        data: data.map(x => Math.round(x.value)),
                    },
                ],
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className="text-center">Ratings Trend</Card.Header>
            <Card.Body className="d-flex flex-column p-1 justify-content-center overflow-auto">
                {loading ? (
                    <LoadingIndicator width={75} />
                ) : error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    data && (
                        <Col className="dashboard-chart ratings">
                            <Chart data={chartData} options={lineTrendOptions} />
                        </Col>
                    )
                )}
            </Card.Body>
        </Card>
    );
}
